import type { NotifyWechatMpStatusVo } from '@/types/api'

/** 服务号状态只在后端确认需要用户操作时展示引导。 */
export function shouldShowWechatGuide(status?: NotifyWechatMpStatusVo | null): boolean {
  return (
    status?.action === 'bind' || status?.action === 'follow' || status?.action === 'select_account'
  )
}

export function getWechatReminderStatusLabel(status?: NotifyWechatMpStatusVo | null): string {
  if (!status) return '暂不可用'
  if (status.action === 'select_account') return '选择服务号'
  if (!status.notificationEnabled) return '未配置'
  if (status.canReceiveNotification) return '已开启'
  if (status.action === 'retry') return '待重试'
  if (status.followStatus === 'not_following') return '待关注'
  return status.action === 'bind' ? '去关联' : '待确认'
}
